import { ManageActionPanel } from "@/overlay/components/LayerStackWindow/ManageActionPanel/ManageActionPanel";

type CrossSectionActionPanelProps = {
  clearCrossSection: () => void;
};

export function CrossSectionActionPanel({ clearCrossSection }: CrossSectionActionPanelProps) {
  return <ManageActionPanel onRemove={clearCrossSection} />;
}
